/**
 * In 2.51.0, we introduced the new market selector. There was an old appconfig setting used in development
 * called "enableNewMarketSelector". For release, we wanted to change the defaulting, so we changed the property used.
 *
 * So the old one is no longer relevant, and is to be removed.
 */
export function removeEnableNewMarketSelectorMigration(config: any) {
  delete config['enableNewMarketSelector'];
}
